type HapticPattern = "light" | "medium" | "success";

const HAPTIC_MAP: Record<HapticPattern, number | number[]> = {
  light: 12,
  medium: 20,
  success: [14, 20, 14],
};

export function triggerAndroidHaptic(pattern: HapticPattern = "light"): void {
  if (typeof navigator === "undefined" || typeof document === "undefined") return;
  if (!("vibrate" in navigator)) return;

  const isAndroidPwa = document.documentElement.classList.contains("android-pwa");
  if (!isAndroidPwa) return;

  try {
    navigator.vibrate(HAPTIC_MAP[pattern]);
  } catch {
    // No-op: haptics are best-effort only.
  }
}
